import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LsTab from '../../components/LsTab';
import styles from '../ProductionPanning/styles.module.scss';
import localStyles from './styles.module.scss';
import { PAGE_TITLE, TIME_STAMP_CONFIG, TAB_CONTENT_TITLE } from './constants';
import TabContent from '../../components/TabContent';
import { fetchRetailProductionPlanTabMetadata } from '../../redux/saga/RetailProductionPlanning/actions';
import { ERROR_MESSAGE } from '../ProductionPanning/DailyComponent/constants';

function RetailPlanPage() {
  const { loading, error, data } = useSelector(
    (state) =>
      state.retailProductionPlanningReducer.retailProductionPlanTabMetadata,
  );

  const { list } = data;
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (list.length > 0 && activeTab === 0) {
      setActiveTab(list?.[0]?.value);
    }
  }, [activeTab, list]);

  useEffect(() => {
    dispatch(fetchRetailProductionPlanTabMetadata());
  }, [dispatch]);

  const tabData = useMemo(() => {
    if (!activeTab) return {};
    return list.find((each) => each.id === activeTab) || {};
  }, [activeTab, list]);

  const handleOpenSheet = (id) => {
    // Handle sheet opening if needed
  };

  return (
    <div>
      <>
        <h2 className={styles.page_heading}> {PAGE_TITLE} </h2>
        {list?.length > 0 && (
          <>
            <div>
              {!error && (
                <div className={styles.pp_slidebar_section}>
                  <div className={localStyles.container}>
                    <div className={localStyles.left_section}>
                      <LsTab
                        list={list || []}
                        value={activeTab || ''}
                        onChange={setActiveTab}
                      />
                      <TabContent
                        title={TAB_CONTENT_TITLE}
                        timeStampConfig={TIME_STAMP_CONFIG}
                        className={localStyles.tab_content}
                        data={tabData}
                        onOpenSheet={handleOpenSheet}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
        {(list.length === 0 || error) && !loading && (
          <>
            <div className={localStyles.main_err_div}>{ERROR_MESSAGE}</div>
          </>
        )}
      </>
    </div>
  );
}

export default RetailPlanPage;
